export const SET_OPEN_LOGIN = 'SET_OPEN_LOGIN'
export const SET_OPEN_REGISTER = 'SET_OPEN_REGISTER'
export const SET_CLOSE_LOGIN = 'SET_CLOSE_LOGIN'
export const SET_ORDERBY = 'SET_ORDERBY'
